"use client";

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { useEditor } from "@/editor/use-editor";
import { Loader2 } from "lucide-react";
import { useTranslations } from "next-intl";

export function MigrationDialog() {
	const t = useTranslations("ProjectDialogs");
	const editor = useEditor();
	const migrationState = editor.project.getMigrationState();

	if (!migrationState.isMigrating) return null;

	const title = migrationState.projectName
		? t("migration.singleTitle")
		: t("migration.multipleTitle");
	const description = migrationState.projectName
		? t("migration.singleDescription", {
				name: migrationState.projectName,
				fromVersion: migrationState.fromVersion ?? "?",
				toVersion: migrationState.toVersion ?? "?",
			})
		: t("migration.multipleDescription", {
				fromVersion: migrationState.fromVersion ?? "?",
				toVersion: migrationState.toVersion ?? "?",
			});

	return (
		<Dialog open={true}>
			<DialogContent
				className="sm:max-w-md"
				onPointerDownOutside={(event) => event.preventDefault()}
				onEscapeKeyDown={(event) => event.preventDefault()}
			>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{description}</DialogDescription>
				</DialogHeader>

				<div className="flex items-center justify-center py-4">
					<Loader2 className="text-muted-foreground size-8 animate-spin" />
				</div>
			</DialogContent>
		</Dialog>
	);
}
